export class Conductor {
    urlFoto: string;
    nombreCompleto: string;
    telefonoMovil: string;
    placa: string;
    idConductor: string;
    idServicio: number;
    idMovil: string;


    constructor(){
        this.nombreCompleto = "Selecione un conductor";
        this.idConductor = '--';
    }
}
